import * as React from "react";
import {
  ActivityFragment,
  ContractTemplateMinimalFragment,
  CompanyMinimalFragment
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { ContractIcon } from "../../icons";
import { Link } from "../../wombat-ui";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type ContractTemplateCreatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: ContractTemplateMinimalFragment;
};

export function isContractTemplateCreatedActivity(
  q: ActivityFragment
): q is ContractTemplateCreatedActivity {
  return q.key === "contract_template.created";
}

interface ContractTemplateCreatedActivityProps {
  activity: ContractTemplateCreatedActivity;
}

export const ContractTemplateCreatedActivity: React.FC<ContractTemplateCreatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="contractTemplateCreatedActivity"
      visual={<ContractIcon iconClassName="w-10 h-10 text-accent-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.contractTemplateCreated", {
          contractTemplate: (
            <Link
              to={`/contracts/templates/edit/${activity.trackable.id}`}
              key={activity.id}
            >
              {t("activity.objects.contractTemplate")}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
